import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Testimonials() {
  const { t } = useTranslation();

  const testimonials = [
    {
      name: 'Marek K.',
      role: 'Entuzjasta sneakersów, Warszawa',
      quote: 'Dzięki Kakobuy Spreadsheet znalazłem produkty, których szukałem od tygodni. Wszystko w jednym miejscu, przejrzyście i szybko. Polecam każdemu!',
      rating: 5,
    },
    {
      name: 'Anna W.',
      role: 'Kupująca online, Kraków',
      quote: 'Na początku byłam sceptyczna, ale Kakobuy Spreadsheet naprawdę ułatwia zakupy. Kategorie są dobrze zorganizowane, a linki zawsze aktualne.',
      rating: 5,
    },
    {
      name: 'Piotr S.',
      role: 'Kolekcjoner streetwear, Gdańsk',
      quote: 'Najlepsze narzędzie do znajdowania perełek. Oszczędzam mnóstwo czasu i znalazłem produkty, których nigdy bym nie odkrył samodzielnie.',
      rating: 5,
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1100px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-accent-600 text-xs font-medium mb-4 whitespace-nowrap">
            Opinie Użytkowników
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            Co mówią nasi użytkownicy
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex gap-0.5 mb-4">
                {[...Array(t.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5 italic">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-xs font-semibold text-accent-600">{t.name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}